const TAG_NAME = 'shopify-planner-helper';
if (!window.customElements.get(TAG_NAME)) {
  class ShopifyPlannerHelper extends HTMLElement {
    constructor() {
      super();
      this._setupListeners();
      this._init();
      this.cartDrawer = document.querySelector('cart-drawer');
    }
    _init() {
      const iframeUrlString = document.querySelector(`${TAG_NAME}`).getAttribute('data-url');
      if (!iframeUrlString) {
        throw new Error('No url was found for the planner.');
      }
      const frameUrl = new URL(iframeUrlString); // TO DO: Change this to https: //planner.audocph.com/us on https://us.audocph.com
      const searchParams = new URL(window.location).searchParams;
      const config = searchParams.get('config');
      if (config) {
        frameUrl.searchParams.append('config', config);
      }
      const family = searchParams.get('family');
      if (family) {
        frameUrl.searchParams.append('family', family);
      }
      frameUrl.searchParams.append('iframe', '1');
      this._setFrameUrl(frameUrl.toString());
    }
    _setFrameUrl(url) {
      const frame = this.querySelector('iframe');
      if (!frame) {
        return;
      }
      frame.src = url;
    }
    _setupListeners() {
      window.addEventListener('message', this._onMessageEvent.bind(this));
    }
    _onMessageEvent(event) {
      if (!event.data?.type) {
        return;
      }
      switch (event.data.type) {
        case 'cart:submit':
          return this._onCartSubmit(event);
      }
    }
    async _onCartSubmit(event) {
      const items = event.data.detail.items.map((item) => this._toIdQtySet(item, event.data.detail.configuration));
      const fetchedCart = await this._addToCart(items);
      if (this.cartDrawer && fetchedCart) {
        this.cartDrawer.renderContents(fetchedCart);
        this.cartDrawer.open();
      }
    }
    _getLocaleAwareUrlRoot(path = '') {
      return window?.Shopify?.routes?.root + path;
    }
    _addToCart(items) {
      return fetch(this._getLocaleAwareUrlRoot('cart/add.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items,
          sections: this.cartDrawer?.getSectionsToRender().map((section) => section.id),
        }),
      }).then((response) => response.json());
    }
    _toIdQtySet(item, configuration) {
      if (!item.variant_id) {
        throw new Error('variant_id not found: Planner is most likely not using ShopifyCheckout or a product is missing a variant_id.');
      }
      return {
        id: item.variant_id,
        quantity: item.quantity,
        properties: {
          _planner_code: configuration.code,
        },
      };
    }
  }
  window.customElements.define(TAG_NAME, ShopifyPlannerHelper);
}
